export default __webpack_public_path__ + "static/media/background.59b86ace.jpg";